import React from 'react';
import ReactDOM from 'react-dom';
import App from './_main/App';

ReactDOM.render(<App />, document.getElementById('root'));
